"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SLOTS = exports.CATEGORY_CLICK_EVENT_HIERARCHY = exports.CATEGORY_BAR_TEST_ID_ITEM = exports.CATEGORY_BAR_TEST_ID = void 0;
var _Arrow = require("./Arrow");
const CATEGORY_CLICK_EVENT_HIERARCHY = exports.CATEGORY_CLICK_EVENT_HIERARCHY = ['select_category', 'Quick links'];
const CATEGORY_BAR_TEST_ID = exports.CATEGORY_BAR_TEST_ID = 'category-bar';
const CATEGORY_BAR_TEST_ID_ITEM = exports.CATEGORY_BAR_TEST_ID_ITEM = 'category-bar-item';
const SLOTS = exports.SLOTS = {
  scrollButtons: _Arrow.Arrow
};
//# sourceMappingURL=constants.js.map